import { IResultado, IResultadoCorrida } from "interfaces/resultadoCorrida";
import api from "./api";

/**
 * Retorna todos os eventos que não possuem resultados - PENDENTES
 * @returns {data: IResultadoCorrida[], status: number}
 * @throws {Error}
 */
export async function getResultadosPendentes(): Promise<{
  data: IResultadoCorrida[];
  status: number;
}> {
  try {
    const { data, status } = await api.get<IResultadoCorrida[]>(
      "/resultados/pendentes"
    );
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação com o servidor");
  }
}

/**
 * Retorna todos os eventos que possuem resultados - PUBLICADOS
 */
export async function getResultadosPublicados(
  condition: "Pendente" | "Publicado" = "Pendente"
): Promise<{
  data: IResultadoCorrida[];
  status: number;
}> {
  try {
    const { data, status } = await api.get<IResultadoCorrida[]>(
      `/resultados/pendentes?condition=${condition}`
    );
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação com o servidor");
  }
}

/**
 * Adiciona ou edita resultados da corrida
 * @param {Partial<IResultado>} resultados - Os dados do resultado a serem adicionados ou editados.
 * @returns {Promise<{ data: any; status: number }>} - Os dados e o status da resposta do servidor.
 * @throws {Error} - Lança um erro se a comunicação com o servidor falhar.
 */
export async function addOrEditResultados(resultados: Partial<IResultado>) {
  try {
    const { data, status } = await api.post("/resultados", resultados);
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação com o servidor");
  }
}

/**
 * UPLOAD RESULTADOS DOS ARQUIVOS PDF
 * @param {FormData} formData - Os dados do resultado a serem adicionados ou editados.
 * @returns {Promise<{ status: number }>} - Os dados e o status da resposta do servidor.
 * @throws {Error} - Lança um erro se a comunicação com o servidor falhar.
 */
export async function uploadResultados(
  formData: FormData,
  eventoId: number,
  resultId: number | null,
  filenameCurrent: string[]
): Promise<{ status: number }> {
  try {
    const { status } = await api.post(`/resultados/upload`, formData, {
      headers: {
        eventoid: eventoId,
        resultid: resultId,
        filenamecurrent: JSON.stringify(filenameCurrent),
      },
    });
    return { status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação com o servidor");
  }
}

/**
 * EXCLUIR ARQUIVO PDF DO RESULTADO
 * @returns {Promise<{ message: string; status: number }>} - Os dados e o status da resposta do servidor.
 * @throws {Error} - Lança um erro se a comunicação com o servidor falhar.
 */
export async function deleteResultadosPdf({
  resultId,
  filenameCurrent,
  filenameToRemove,
}: {
  resultId: number;
  filenameCurrent: string[];
  filenameToRemove: string[];
}): Promise<{ message: string; status: number }> {
  try {
    const { data, status } = await api.delete("/resultados/remove-pdf", {
      data: { resultId, filenameCurrent, filenameToRemove },
    });
    return { message: data.message, status };
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}
